// são dois valores para o CNPJ porque o Imovel pode ter origem em dois serviços
export enum TipoNIImovel {
  CPF = '2',
  CNPJ = '4',
  CNPJ2 = '1'
}
